"use client"
import { Link } from "@tanstack/react-router"
import { useState } from "react"
import { FaLock } from "react-icons/fa6"
import { LuClock } from "react-icons/lu"
import { Card } from "~/components/ui/card"
import type { Group } from "@apps/gwservice/types"
import { SubscribeButton } from "~/features/group/components/subscribe-button"
import { PlansTrigger } from "~/features/plans/components/plans-drawer"
import { GroupAccessSheet } from "./group-access-sheet"
import { RemoteImg } from "~/components/ui/remote-img"

interface Props {
  group: Group
}

function CardContent({ group }: Props) {
  return (
    <Card className="flex flex-row items-center p-0! w-full">
      <div className="relative size-group-img shrink-0">
        {group.avatar?.url ? (
          <RemoteImg src={group.avatar.url} alt={group.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-muted" />
        )}
      </div>
      <div className="flex-1 px-m">
        <div className="text-base line-clamp-2 hyphens-auto" lang="ru">
          {group.name}
        </div>
      </div>
      <div className="pr-m">
        {group.planLocked ? (
          <FaLock className="size-icon-s shrink-0 text-muted-foreground" />
        ) : group.access === "pending" ? (
          <LuClock className="size-icon-s shrink-0 text-muted-foreground" />
        ) : group.access === "denied" ? (
          <FaLock className="size-icon-s shrink-0 text-muted-foreground" />
        ) : (
          <SubscribeButton
            groupId={group.id}
            isSubscribed={group.isSubscribed}
            variant="ghost"
            className="text-primary -mx-s"
          />
        )}
      </div>
    </Card>
  )
}

export function GroupCard({ group }: Props) {
  const [open, setOpen] = useState(false)

  if (group.planLocked) {
    return (
      <PlansTrigger>
        <CardContent group={group} />
      </PlansTrigger>
    )
  }

  if (group.isRestricted) {
    return (
      <>
        <div className="w-full" onClick={() => setOpen(true)}>
          <CardContent group={group} />
        </div>
        <GroupAccessSheet group={group} open={open} onClose={() => setOpen(false)} />
      </>
    )
  }

  return (
    <Link
      to="/group/$id"
      params={{
        id: String(group.id),
      }}
    >
      <CardContent group={group} />
    </Link>
  )
}
